export const SHARED_LOCATION_ENDPOINT = "share-location";

export const DEFAULT_SHARE_LOCATION_SESSION_DURATION = 15;
export const REFRESH_SHARED_LOCATION_MS = 3000;
export const REFRESH_SHARED_LOCATION_ERROR_RETRY_MS = 30000;
export const EXPIRATION_CHECK_INTERVAL_MS = 5000;
export const UI_UPDATE_INTERVAL_MS = 10000;

export const SHARED_SESSION_ID_KEY = "situm_shared_session_id";
